import Cookies from 'js-cookie'

const actions = {
  async authenticate ({ commit, state, dispatch }, reqData) {
    await dispatch('initCsrf')

    return new Promise((resolve, reject) => {
      this._vm.$http.post('/login', reqData).then(({ data }) => {
        commit('authenticate')
        commit('authUser', data)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  authUser ({ commit, state }) {
    return this._vm.$http.get('/user').then(({ data }) => {
      commit('authenticate')
      commit('authUser', data)
    }).catch(err => {
      console.log(err)
      commit('logout')
    })
  },
  logout ({ commit, state }) {
    return new Promise((resolve, reject) => {
      this._vm.$http.post('/logout').then(() => {
        commit('logout')
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  async forgotPassword ({ commit, state, dispatch }, reqData) {
    await dispatch('initCsrf')

    return new Promise((resolve, reject) => {
      this._vm.$http.post('/password/email', reqData).then(() => {
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  async resetPassword ({ commit, state, dispatch }, reqData) {
    await dispatch('initCsrf')

    return new Promise((resolve, reject) => {
      this._vm.$http.post('/password/reset', reqData).then(({ data }) => {
        commit('authenticate')
        commit('authUser', data)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  async activateUser ({ commit, state, dispatch }, reqData) {
    await dispatch('initCsrf')

    return new Promise((resolve, reject) => {
      this._vm.$http.put('/user/invite', reqData).then(({ data }) => {
        commit('authenticate')
        commit('authUser', data)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  initCsrf ({ commit, state }) {
    if (!Cookies.get('XSRF-TOKEN')) {
      return this._vm.$http.get('/csrf-cookie').catch(err => {
        if (!err.response || !err.response.status !== 422) {
          this._vm.$notify({
            message: 'Server Error',
            type: 'danger'
          })
        }
      })
    }
  }
}

export default actions
